import React from "react";

import checkedBlueIcon from "../../assets/admin/icons/checked-blue.svg";
import uncheckedBlueIcon from "../../assets/admin/icons/unchecked-blue.svg";

const CustomCheckbox = ({ checked, text, onToggle }) => {
   return (
      <div onClick={onToggle} className="custom-checkbox g-15-1fr">
         {checked ? (
            <img src={checkedBlueIcon} alt="checked"></img>
         ) : (
            <img src={uncheckedBlueIcon} alt="unchecked"></img>
         )}
         <span>{text}</span>
      </div>
   );
};

export default CustomCheckbox;
